import script from "./RunGroupDetailInfoContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./RunGroupDetailInfoContent.vue?vue&type=script&setup=true&lang=ts"

import "./RunGroupDetailInfoContent.vue?vue&type=style&index=0&id=34bf1d37&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34bf1d37"]])

export default __exports__